import { Divider, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
} from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import WSButton from "../../../../Components/Button/WSButton";
import WSHiddenField from "../../../../Components/HiddenField/WSHiddenField";
import WSTextField, { CurrencyType, TextType } from "../../../../Components/TextBox/WSTextBox";
import { AppState } from "../../../../StateManagement/types";
interface  ProductProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    productId?: string;
    setValue: UseFormSetValue<any>;
    onCancel:()=>void
    data?:any
}

const ProductDrawyer: React.FC<ProductProps> = ({
  control, errors, register, id, reset,  setValue,data,onCancel,productId
}) => {

      useEffect(() => {
        return () => {
            reset();
        };
    }, []);
  useEffect(()=>{
    if(data){
      setValue('name',data?.name)
      setValue('code',data?.code)
      setValue('unit',data?.unit)
      setValue('unitPrice',data?.unitPrice)
      setValue('tax',data?.tax)
      setValue('productId',data?.id)
    }
  },[data,setValue,productId])
  const reduxComponentData = useSelector(
    (state: AppState) => state.components["productSubmit"],
    shallowEqual 
  );

  // Local state to store Redux data
  const [componentData, setComponentData] = useState(reduxComponentData);

  // Update useState when Redux state changes
  useEffect(() => {
    if (reduxComponentData) {
      setComponentData(reduxComponentData);
    }
  }, [reduxComponentData]);
  return (
    <Grid >
      {<Grid  container spacing={2}  mt={2}>

            <Grid item xs={12}>
              <Typography fontWeight={"bold"}>Product Information</Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
            <WSTextField
                label={"Product Name"}
                {...register("name")}
                id="name"
                name="name"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Product Code"}
                {...register("code")}
                id="code"
                name="code"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Unit"}
                {...register("unit")}
                id="unit"
                name="unit"
                control={control}
                rules={{ required: true }}
              
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Unit Price"}
                {...register("unitPrice")}
                id="unitPrice"
                name="unitPrice"
                control={control}
                rules={{ required: true }}
                type={TextType.Currency}
                currency={CurrencyType.Rupee}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Tax"}
                {...register("tax")}
                id="tax"
                name="tax"
                control={control}
                rules={{ required: false }}
                type={TextType.Currency}
                currency={CurrencyType.Rupee}
              />
              <WSHiddenField control={control} name="productId" defaultValue={productId} />
            </Grid>
            <Grid item xs={12} sm={12}>
                <Divider />
                </Grid>

            <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton  className="ws-theme-crm" variant="outlined" id='productSubmit' label={"Save"} type="submit" size="medium" loading={reduxComponentData?.data?.loading}  />
                    </Grid>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton  id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium"  variant="outlined"  className="ws-theme-crm" />
                    </Grid>
                </Grid>
          </Grid>
   }
    </Grid>
  );
};
export default ProductDrawyer;
